import type { FC } from "react"

export const NoValuePlaceholder: FC = () => <span className='whitespace-nowrap font-normal text-gray-500'>No data</span>
